import { Box, Heading, HStack, Image, Stack, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import MainLayout from '../../components/layout/MainLayout';

export default function ErrorPage() {
  const { t } = useTranslation();
  return (
    <MainLayout hideFooter hideHeader title={t('landingPage.seoTitle')} description={t('landingPage.seoDescription')}>
      <Stack align="center" textAlign="center" h="80vh" justifyContent="center">
        <Box>
          <Image className="lazyload" width="80px" objectFit="cover" src="/assets/character/fun_purple.png" alt="Flate" />
        </Box>
        <Heading>{t('errorPage.title')}</Heading>
        <Text fontWeight="bold">{t('errorPage.workingOnIt')}</Text>
        <HStack spacing={1} flexDir={{ base: 'column', md: 'row' }}>
          <Text>{t('errorPage.stillProblem')}</Text>
          <Text>
            {t('errorPage.textTo')}{' '}
            <strong>
              <a href="https://www.linkedin.com/in/gianmarco-ebeling-856020135/">CTO</a>{' '}
            </strong>
            &{' '}
            <strong>
              <a href="https://www.linkedin.com/in/francesco-anastasio-57915684/">CIO</a>{' '}
            </strong>
            {t('errorPage.hurryUp')}
          </Text>
        </HStack>
      </Stack>
    </MainLayout>
  );
}
